if(!customElements.get('landing-section')) {
  class LandingSection extends HTMLElement {
    constructor() {
      super();

      this.observedEl = this.querySelector('[data-landing]');
      this.observer = new IntersectionObserver((entries, observer) => entries.forEach((entry) => {
        const { isIntersecting } = entry;
        this.toggleOverflow(isIntersecting);
      }), { threshold: [0, 0.25, 0.5, 0.75, 1] });
    }
    
    connectedCallback() {
      this.checkForDesktop();
      window.addEventListener('resize', this.checkForDesktop.bind(this));
    }

    checkForDesktop() {
      this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      this.isDesktop ? this.observer.observe(this.observedEl) : this.observer && this.observer.disconnect();
      this.isDesktop ? window.scrollTo(0,0) : document.body.classList.remove('overflow-hidden');
    }

    toggleOverflow(isIntersecting) {
      if(isIntersecting) {
        document.body.classList.add('overflow-hidden');
        this.parentNode.classList.remove('scrolled');
      } else {
        document.body.classList.remove('overflow-hidden');
        this.parentNode.classList.add('scrolled');
      }
    }
  }

  customElements.define('landing-section', LandingSection);
}